import { createProfessionalExporter } from '../../../utils/professionalExport';

const headers = [
  'Package Name',
  'Serial No',
  'Branch',
  'Members',
  'Status',
];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Package List',
  headers,
  slug: 'packages',
  getRows: (list) =>
    list.map((pkg) => [
      pkg.name,
      pkg.serialNo !== '' && pkg.serialNo != null ? `ID-${pkg.serialNo}` : '—',
      pkg.branch || '—',
      pkg.members,
      formatStatus(pkg.status),
    ]),
  getSummary: (list) => [
    `Total packages: ${list.length}`,
    `Active: ${list.filter((p) => p.status === 'active').length}`,
  ],
});

export const printPackageList = (data) => exporter.print(data);
export const exportPackageCsv = (data) => exporter.csv(data);
export const exportPackageExcel = (data) => exporter.excel(data);
export const exportPackagePdf = (data) => exporter.pdf(data);
export const exportPackages = (data) => exporter.export(data);
